import { SecondaryButton, Spinner } from "@graffer-inc/console-design-kit";
import * as React from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { connectPageService } from "../../../../../application/domain/base/base-application-service";
import {
  OrganizationUserDetailServiceProps,
  OrganizationUserDetailService,
} from "../../../../../application/service/service-provider/user-detail-service";
import { useModal } from "../../../../../utils/custom-hooks";
import { DisableTOTPConfirmModal } from "../../../../organisms/smart-apply/modals/disable-totp-confirm-modal";
import { LoginLockResetConfirmModal } from "../../../../organisms/smart-apply/modals/login-lock-reset-confirm-modal";
import { PasswordResetConfirmModal } from "../../../../organisms/smart-apply/modals/password-reset-confirm-modal";
import { ServiceProviderTemplate } from "../../../../template/service-provider/default-template";
import { ServiceProviderR } from "../../routes";
import { convertToFormattedId } from "@graffer-inc/cloud-gov-core";
import { UserBasicInfo } from "../../../../organisms/settings/user-detail";
import { useAuthContext } from "../../../../../auth-state";

export const OrganizationUserDetail: React.FC<
  OrganizationUserDetailServiceProps
> = ({
  user,
  groups,
  isLoading,
  setParamId,
  fetchUser,
  fetchGroupCandidates,
  updateUser,
}) => {
  const authState = useAuthContext();
  const { orgId, userId } = useParams<{ orgId: string; userId: string }>();

  const passwordResetModal = useModal();
  const disableTOTPModal = useModal();
  const loginLockResetModal = useModal();

  useEffect(() => {
    setParamId(orgId, userId);
    fetchUser();
  }, [fetchUser, orgId, setParamId, userId]);

  return (
    <ServiceProviderTemplate
      breadcrumbs={[
        {
          to: ServiceProviderR.OrgUsers.link({ orgId }),
          title: "ユーザー一覧",
        },
        {
          to: ServiceProviderR.OrgUserDetail.link({ orgId, userId }),
          title: convertToFormattedId(userId),
        },
      ]}
    >
      <Spinner loading={isLoading} />
      <nav className="level">
        <div className="level-left">
          <h1 className="title">
            <i className="fa fa-user" /> ユーザー詳細
          </h1>
        </div>
        <div className="level-right">
          <p className="level-item">
            <SecondaryButton
              text="パスワードリセット"
              onClick={passwordResetModal.open}
            />
          </p>
          <p className="level-item">
            <SecondaryButton
              text="2段階認証の無効化"
              onClick={disableTOTPModal.open}
            />
          </p>
          <p className="level-item">
            <SecondaryButton
              text="ロック解除"
              onClick={loginLockResetModal.open}
            />
          </p>
        </div>
      </nav>
      <hr />
      {user && (
        <>
          <div className="c-use-detail--wrapper">
            <UserBasicInfo
              user={user}
              groups={groups}
              fetchUser={fetchUser}
              fetchGroupCandidates={fetchGroupCandidates}
              updateUser={updateUser}
              isServiceProvider={authState.isServiceProviderAccount()}
            />
          </div>
          <PasswordResetConfirmModal
            title="パスワードリセット"
            user={user}
            isActive={passwordResetModal.isActive}
            onClose={() => {
              passwordResetModal.close();
              fetchUser();
            }}
          />
          <DisableTOTPConfirmModal
            title="2段階認証の無効化"
            user={user}
            isActive={disableTOTPModal.isActive}
            onClose={() => {
              disableTOTPModal.close();
              fetchUser();
            }}
          />
          <LoginLockResetConfirmModal
            title="ログインロックの解除"
            user={user}
            isActive={loginLockResetModal.isActive}
            onClose={() => {
              loginLockResetModal.close();
              fetchUser();
            }}
          />
        </>
      )}
    </ServiceProviderTemplate>
  );
};

export const OrganizationUserDetailContainer = connectPageService(
  OrganizationUserDetail,
  () => new OrganizationUserDetailService(),
);
